import { useState, useEffect } from 'react';
import { IconUp, IconDown } from '@ui/src';
import { IndividualApplicationStepOneAdditionalBlockTypes } from './types';

import cn from '../styles.module.css';

const StepOneAdditionalBlock = ({
  title,
  children,
  defaultOpen,
}: IndividualApplicationStepOneAdditionalBlockTypes) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setCollapsed(defaultOpen as boolean);
  }, [defaultOpen]);

  return (
    <div className={cn.additionalInfoBlock}>
      <button
        type="button"
        className={cn.additionalInfoButton}
        onClick={() => setCollapsed(!collapsed)}
      >
        {title}
        <div className={cn.iconWrapper}>
          {collapsed ? <IconUp /> : <IconDown />}
        </div>
      </button>
      {collapsed && (
        <div className={cn.additionalInfoBlockContent}>{children}</div>
      )}
    </div>
  );
};

export default StepOneAdditionalBlock;
